import CommonLayout from './CommonLayoutContainer';

export default CommonLayout;
